<div class="dropdown">
    <button class="btn btn-ms-secondary dropdown-toggle d-flex align-items-center gap-2 rounded-end-0" type="button" id="countryCodeDropdown"
        (click)="toggleDropdown()" [attr.aria-expanded]="showDropdown()">
        @if (selectedCountry) {
            <img src="/ms/images/flags/{{selectedCountry.flag}}.svg" alt="{{selectedCountry.name}}" class="flag-icon" />
            <span class="fw-medium">+{{selectedCountry.dialCode}}</span>
        }
    </button>
    <ul class="dropdown-menu" [class.show]="showDropdown()" aria-labelledby="countryCodeDropdown" style="max-height: 300px; overflow-y: auto;">
        @for (country of countryCodes; track country.code) {
            <li>
                <a class="dropdown-item d-flex align-items-center gap-3 py-2" (click)="selectCountry(country)" role="button">
                    <img src="/ms/images/flags/{{country.flag}}.svg" alt="{{country.name}}" class="flag-icon" />
                    <span class="flex-grow-1">{{country.name}}</span>
                    <span class="small fw-medium">+{{country.dialCode}}</span>
                </a>
            </li>
        }
    </ul>
</div>
